// === Task 31 === Scene card — clickable summary tile used by every Flow
// Viewer mode. Receives pre-computed reads/writes/outbound from
// analyzeWorkflow.js; no Redux access here so it stays trivially testable.
import React from "react";

export default function SceneCard({ scene, title, reads, writes, outbound, onJump }) {
  if (!scene) return null;
  const tint =
    writes && writes.length > 0
      ? "scene-card--writes"
      : reads && reads.length > 0
        ? "scene-card--reads"
        : "scene-card--static";

  const handleClick = () => {
    if (onJump) onJump(scene.id);
  };

  const displayName = title || scene.title || scene.name || scene.id;

  return (
    <button type="button" className={`scene-card ${tint}`} onClick={handleClick} title={scene.id}>
      <div className="scene-card__name">{displayName}</div>
      {writes && writes.length > 0 && (
        <div className="scene-card__badge scene-card__badge--writes">
          writes: {writes.join(", ")}
        </div>
      )}
      {reads && reads.length > 0 && (
        <div className="scene-card__badge scene-card__badge--reads">reads: {reads.join(", ")}</div>
      )}
      {outbound && outbound.length > 0 && (
        <div className="scene-card__badge scene-card__badge--jumps">→ {outbound.join(", ")}</div>
      )}
    </button>
  );
}
